import r from "./ghl-ui.es1308.js";
function o(t) {
  return t == null ? "" : r(t);
}
export {
  o as default
};
